import { gql } from "@apollo/client";

export const GetFinYrs = gql`
  query GetFinYrs($token: String!, $customerID: ID!, $companyID: ID!) {
    GetFinYrs(token: $token, customerID: $customerID, companyID: $companyID) {
      id
      finYr
      finStDate
      finEndDate
      finIsCurrYr
    }
  }
`;

export const GetActiveFinYr = gql`
  query GetActiveFinYr($token: String!,  $customerID: ID!, $companyID: ID!) {
    GetActiveFinYr(token: $token, customerID: $customerID, companyID: $companyID) {
      id
      finYr
      finStDate
      finEndDate
      finIsCurrYr
    }
  }
`;
